import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {useQuery} from "@tanstack/react-query";
import {Template} from "../../../../components/template/template.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaEraser, FaPlus, FaSearch} from "react-icons/fa";
import {Card} from "../../../../components/card/card.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../utils/aggrid-utils.js";
import groupService from "../../../../services/web/group-service.js";
import {navigateHook} from "../../../../hooks/use-navigate.js";
import {useGlobalKey} from "../../../../hooks/use-global-key.js";

const GroupList = () => {
    const navigate = navigateHook();

    const [data, setData] = useState([])
    const [filter, setFilter] = useState("");

    const {data: dataFetch, isSuccess} = useQuery({
        queryFn: () => groupService.list(),
        queryKey: ["group-list"]
    });

    useEffect(() => {
        if (!isSuccess) return;

        setData(dataFetch);
    }, [isSuccess]);

    const [columnDefs,] = useState([
        {
            field: "name",
            headerName: "Nome",
            sort: "asc",
            flex: 1,
            comparator: (a, b, nodeA, nodeB, isInverted) => {
                return aggridUtils.nullLastComparator(a, b, nodeA, nodeB, isInverted);
            }
        },
    ]);

    const gridRef = useRef(undefined);

    const defaultColDef = useMemo(() => ({resizable: false}), []);

    const apply = useCallback(() => {
        setData(dataFetch?.filter(d => d.name?.toLowerCase().includes(filter?.toLowerCase())))
    }, [filter, dataFetch])

    const clear = useCallback(() => {
        setData(dataFetch);
        setFilter("");
    }, [dataFetch])

    useGlobalKey("Enter", apply);
    useGlobalKey("Escape", clear);

    const onCellClicked = ({data, event}) => {
        const isBlank = event.ctrlKey
        navigate(`/group/form/${data.id}`, isBlank);
    };

    return (
        <Template>
            <Template.Header>
                <Template.Title>Grupos de operação</Template.Title>

                <Button target={"primary"} onClick={() => navigate("/group/form")}>
                    <FaPlus/> Adicionar grupo
                </Button>
            </Template.Header>

            <Template.Body className={"space-y-2"}>
                <Card>
                    <Card.Body>
                        <div className="flex justify-between gap-4">
                            <InputForm
                                classNameWrapper={"w-full"}
                                id={"name"}
                                label={"Nome"}
                                name={"name"}
                                value={filter}
                                onChange={({target: {value}}) => setFilter(value)}
                            />

                            <div className={"flex gap-2"}>
                                <Button target={"default"} onClick={clear} title={"Limpar"}>
                                    <FaEraser />
                                </Button>
                                <Button onClick={apply} title={"Buscar"}>
                                    <FaSearch />
                                </Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                <Card>
                    <Card.Body>
                        <div className={"h-[calc(100vh-153px)] aggrid-row-pointer"}>
                            <AgGridReact
                                ref={gridRef}
                                rowData={data ?? []}
                                columnDefs={columnDefs}
                                defaultColDef={defaultColDef}
                                pagination
                                paginationPageSize={100}
                                paginationPageSizeSelector={[20, 50, 100, 500]}
                                animateRows={false}
                                suppressCellFocus={true}
                                onCellClicked={onCellClicked}
                                gridOptions={{localeText: aggridUtils.localization()}}
                                theme={aggridUtils.generalTheme()}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
};

export default GroupList;